import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ValidationService } from 'src/shared/shared-forms/validation.service';

@Component({
  selector: 'vl-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.scss'],
  imports: [NgIf, TranslatePipe],
})
export class ValidationComponent implements OnInit, OnChanges {
  @Input() errorName;
  @Input() value;
  @Input() fieldName;
  public message;

  constructor(private validationService: ValidationService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.errorName && changes.errorName.currentValue) {
      this.message = this.validationService.getErrMessage(this.errorName, this.fieldName, this.value);
      // console.log('this.message', this.message);
    }
  }

  ngOnInit(): void {
  }


}
